<h1 mat-dialog-title>Gutschrift {{ gutschrift ? "editieren" : "hinzufügen" }}</h1>
<div mat-dialog-content>
    <kiene-autocomplete
        #lieferantAuto
        (elementSelected)="supplierSelected($event)"
        [apiUrl]="'lieferant/'"
        [disabled]="!lieferantFocus"
        [focus]="false"
        [kieneObject]="lieferant"
        [placeholder]="'Lieferant'"
        [presetSelected]="false"
    ></kiene-autocomplete>
    <kiene-article-scan-autocomplete
        (selectedMaterial)="materialSelected($event)"
        [params]="artikelParams"
        [placeholder]="'Artikel'"
        [presetMaterial]="material"
    ></kiene-article-scan-autocomplete>
    <!--    <kiene-autocomplete #artikelAuto (elementSelected)="materialSelected($event)" [apiUrl]="'artikel/'" [focus]="false"-->
    <!--                        [kieneObject]="material" [params]="artikelParams"-->
    <!--                        [placeholder]="'Artikel'"></kiene-autocomplete>-->
    <div class="one-row betrag-mwst-row">
        <mat-form-field class="field-betrag">
            <mat-label>Betrag (netto) in Euro</mat-label>
            <input #betragInput [formControl]="betragCtrl" matInput kieneDeNumber inputmode="decimal" />
            <span matSuffix>&euro;</span>
        </mat-form-field>
        <mat-form-field class="field-mwst">
            <mat-label>MwSt</mat-label>
            <mat-select [formControl]="mwstsatzCtrl">
                <mat-option *ngFor="let s of mwstSaetze" [value]="s.value">{{ s.label }}</mat-option>
            </mat-select>
        </mat-form-field>
        <button
            mat-icon-button
            type="button"
            class="mwst-calc-btn"
            (click)="mwstVomBetragAbziehen()"
            [disabled]="!canMwstVomBetragAbziehen()"
            matTooltip="MwSt abziehen (Brutto → Netto)"
        >
            <mat-icon>calculate</mat-icon>
        </button>
    </div>
    <mat-form-field style="width: 100%">
        <mat-label>Gutschrift Nr.</mat-label>
        <input [formControl]="gutschriftNrCtrl" matInput />
    </mat-form-field>
    <mat-form-field style="width: 100%">
        <mat-label>Kommentar</mat-label>
        <input [formControl]="kommentarCtrl" matInput maxlength="500" />
    </mat-form-field>
    <mat-form-field style="width: 100%">
        <mat-label>Gutschriftdatum</mat-label>
        <input [formControl]="datumCtrl" [matDatepicker]="picker" matInput placeholder="Datum Gutschrift" />
        <mat-datepicker-toggle [for]="picker" matSuffix></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>
    <button (click)="openFileSelector()" color="accent" mat-flat-button>Gutschrift als PDF hinzuf&uuml;gen</button>
    <input #fileSelector (change)="handleFiles($event)" accept="application/pdf" style="display: none" type="file" />

    <div *ngIf="filesToUpload.length > 0">
        <mat-list>
            <h4 mat-subheader>Dateien</h4>
            <div *ngFor="let file of filesToUpload; let i = index" style="width: 100%">
                <div class="one-row" style="margin-bottom: 12px">
                    <mat-icon mat-list-icon style="width: 70px">insert_drive_file</mat-icon>
                    <div style="min-width: 40%">{{ file.name }}</div>
                    <mat-icon *ngIf="filesUploadStatus[i] == 1" color="primary">check</mat-icon>
                    <mat-icon *ngIf="filesUploadStatus[i] == 2" color="warn">warning</mat-icon>
                    <span class="spacer"></span>
                    <mat-progress-spinner [diameter]="30" [value]="filesProgressValues[i]" mode="determinate">
                    </mat-progress-spinner>
                </div>
            </div>
        </mat-list>
    </div>
</div>
<div mat-dialog-actions>
    <button (click)="close()" mat-button>Abbrechen</button>
    <button (click)="save()" [disabled]="!lieferant || !betragCtrl.valid" color="accent" mat-flat-button
        >Gutschrift Speichern
    </button>
</div>
